/**
 * Module with generic scripts.
 * Should be included in all pages except pages without common menu.
 */

require('pages/_base_page_commons');
require('pages/partials/commonmenu');
